import Vue from 'vue'

export default {
  LOAD_JOB (state, payload) {
    state.job = payload || {}
  },
  LOAD_JOB_SEARCH_RESULTS (state, payload) {
    state.results = payload || []
  },
  LOAD_JOB_SEARCH_TOTAL (state, payload) {
    state.total = payload || 0
  },
  LOAD_JOB_SEARCH_FROM (state, payload) {
    state.from = payload || 0
  },
  LOAD_JOB_SEARCH_SIZE (state, payload) {
    state.size = payload || 10
  },
  LOAD_JOB_SEARCH_PAGE_NUMBER (state, payload) {
    state.pageNumber = payload || 1
  },
  LOAD_JOB_SEARCH_AGGREGATIONS (state, payload) {
    state.aggregations = payload || {}
  },
  LOAD_JOB_SEARCH_TERMS (state, payload) {
    state.terms = payload || ''
  },
  LOAD_JOB_SEARCH_SORT (state, payload) {
    state.sort = payload || []
  },
  LOAD_JOB_LIBRARY_POSITION_MAPPING (state, payload) {
    state.libraryPositionMapping = payload || {}
  },
  UPDATE_JOB_SELECTED_FACETS (state, payload) {
    Vue.set(state.selectedFacets, payload.key, payload.value || [])
  }
}



// WEBPACK FOOTER //
// ./src/app/job/vuex/mutations.js